
export const paginationInitialState = {
  limit: 30,
  offset: 0,
  count: 0
}

export const filterInitialState = {
  contractNumber: null,
  subdivisionNames: null,
  overdueType: null,
  clientPhone: null,
  eventResultCode: null,
  assignTo: null,
  contactType: null,
  clientLastName: null,
  overdueDaysTo: null,
  overdueDaysFrom: null,
  creditProductName: null,
  clientIin: null,
  completedByFrom:null,
  completedByTo: null,
  sortBy: 'overdueDays',
  sortDirection: 'desc',
  level:null,

  applicationType: null,
  applicationStatus:null,
  workListStatusCode:null,
  creditProducts: null,
  loanAmountFrom: null,
  loanAmountTo: null,
  overdueTranchesSumFrom: null,
  overdueTranchesSumTo: null,
  applicationDateFrom: null,
  applicationDateTo: null,
  clientFullName: null
}

export const eventsInitialState = {
  established: true,
  description: null,
  dueDate: null,
  contactType: null,
  eventTypeCode: null,
  eventResultCode: null,
  phoneNumber: null
}

export const lawyerEventsInitialState = {
  description: null,
  legalTypeCode: null,
  legalResultCode: null
}

export const deferralInitialState = {
  deferralType: '',
  suspension: {
    termMonths: '',
    startDate: null,
    reason: '',
    otherReason: '',
    files: {
      application: null,
      workCertificate: null,
      incomeProof: null
    }
  },
  writeOff: {
    reason: ''
  },
  buyback: {
    car: { brand: '', model: '', plate: '', vin: '' },
    files: {
      inspectionReport: null,
      buybackConsent: null
    }
  }
}

export const countsInitialState = { OFFBALANCE: 0, LEGAL: 0, HARD: 0, SOFT: 0 }

export const contractInitialState = {
  id: null,
  status: null,
  overdueType: null,
  overdueDays: null,
  assignTo: null,
  assignToFullName: null,
  comment: null,
  contractNumber: null,
  clientFullName: null,
  subdivisionName: null,
  creditProductName: null,
  loanAmount: null,
  overdueTranchesSum: null,
  events: [],
  contract: {
    id: null,
    contractId: null,
    clientId: null,
    contractName: null,
    creditProductName: null,
    loanAmount: null,
    subdivisionName: null,
    issueDate: null,
    closeDate: null,
    defermentEndDate: null,
    interestForTranche: null,
    trancheCount: null,
    paymentsAmount: null,
    paymentsNumber: null,
    outstandingPaymentsNumber: null,
    repaymentPlanDate: null,
    statusOverdueDays: null,
    factOverdueDays: null,
    numberOverduePayments: null,
    creationDate: null,
    loadingDate: null,
    contractCode: null,
    currencyName: null,
    loanStage: null,
    branchName: null,
    creditOfficerName: null,
    donorName: null,
    loanCategoryName: null,
    defermentType: null,
    defermentDistributionType: null,
    defermentTranchesQty: null,
    defermentProlongationTranchesQty: null,
    trancheDuration: null,
    repaymentSequenceName: null,
    penaltyTypeName: null,
    interestLgotPeriod: null,
    interestLgotRate: null,
    interestGracePeriod: null,
    delinquencyIntRate: null,
    dateCalcMethodName: null,
    interestRateTypeName: null,
    interestCalcMethodName: null,
    interestChargeMethodName: null,
    principalDistribMethodName: null,
    forepaymentConsiderationMethodName: null,
    creditLineId: null,
    mandatoryChargePeriod: null,
    extraIntDaysQty: null,
    prolongationPeriod: null,
    qtyDaysStopPenaltyOnClose: null,
    delinqIntRateDelay: null,
    fixedDelayPenalty: null,
    delayPenaltyDay: null,
    depositorFullName: null,
    collateralName: null,
    assessedValue: null,
    hypothecationValue: null,
    loanValue: null,
    document: null,
    comment: null,
    collateralCreationDate: null,
    initialPaymentAmount: null,
    carMark: null,
    carModel: null,
    carYear: null,
    dealerShop: null,
    dealerGroup: null,
    carName: null,
    initialPaymentRatio: null,
    carColor: null,
    carCondition: null,
    carBody: null,
    carMileage: null,
    carPlate: null,
    carRegistrationCertificate: null,
    carRegistrationDate: null,
    carVinCode: null,
    refresh: null,
    availableCollateralAndInformation: null,
    earlyProlongationFromCurrentDate: null,
    fullScheduleDatesRecalc: null,
    scheduleRecalcEnabled: null,
    firstWeekendWithoutPenalty: null,
    shortTermControl: null,
    interestOnLoanAmount: null,
    allowHolidaysPayment: null,
    calcInterestOnDelinqBalance: null,
    calcIntOnDelinqBalanceOnlyAtDelinqIntRate: null,
    calcIntOnIssueDate: null,
    chargeExtraInterest: null,
    allowPrepayment: null,
    calendarDaysPenalty: null,
    stopPenaltyOnClose: null,
    keepUsingDelinqIntRate: null,
    useDelinqIntRateForPsk: null,
    prolongationOnNewSchedule: null,
    useDelinqIntRateTillNextTranche: null
  }
}
